import React from 'react';
import { StyledCheckIcon } from './styles';
import type { CheckIconStyling } from './types';

const CheckIcon: React.FC<CheckIconProps> = ({
  checked = false,
  partial = false,
  height = 8,
  left = 0,
  top = 0,
  strokeWidth = '4',
  styling = 'primary',
}) => {
  return (
    <StyledCheckIcon
      $styling={styling}
      height={height}
      width={height}
      viewBox="0 0 34 34"
      fill="none"
      strokeLinecap={'miter' as any}
      strokeLinejoin={'butt' as any}
      strokeWidth={strokeWidth}
      stroke="currentcolor"
      style={{
        left,
        top,
      }}
    >
      {checked && <path d="M3 16 L14 24 26 4" />}
      {partial && <path d="M4 16 L24 16" />}
    </StyledCheckIcon>
  );
};

interface CheckIconProps {
  checked?: boolean;
  partial?: boolean;
  height?: number;
  left?: number;
  top?: number;
  strokeWidth?: number | string;
  styling?: CheckIconStyling;
}

export default CheckIcon;
